module.exports = __webpack_public_path__ + "static/media/logo_alaquas.8a9296aa.png";